import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  AfterViewChecked,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { DatePipe, DecimalPipe } from "@angular/common";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { SessionStorage } from "ngx-webstorage";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSnackBar,
} from "@angular/material";
import { DashboardService } from "../dashboard/dashboard.service";
import { TimesheetEntryService } from "./timesheet-entry.service";
import {
  Leave,
  DateDisplay,
} from "../../employee/timesheet-entry/timesheet.interface";
import { takeWhile } from "rxjs/operators";
import {
  ProjectDetails,
  TaskDetails,
  TaskDetailsAccenture,
  TaskDetailsBiologics,
  DropDownProject,
  DropDownTask,
  Locked,
  NonIPDODropDownTask,DropDownTargetId
} from "../../employee/employee.interface";
import { PopoverModule } from "ngx-popover";
import { ConfigService } from "../../utils/services/config.service";
import { TimeSheetEntry } from "../../utils/models/config";
import { TimesheetApprovalsService } from "../timesheet-approvals/timesheet-approvals.service";
import { ErrorPopUpComponent } from "../../common/error-pop-up/error-pop-up.component";
import { RequestUnlockDialogComponent } from "../../employee/dashboard-employee/request-unlock-dialog/request-unlock-dialog.component";
import { ConfirmPopUpComponent } from "../../common/confirm-pop-up/confirm-pop-up.component";
import { LeavePopUpComponent } from "../../common/leave-pop-up/leave-pop-up.component";
import { DeleteEntryPopUpComponent } from "../../common/delete-entry-pop-up/delete-entry-pop-up.component";

@Component({
  selector: "app-timesheet-entry",
  templateUrl: "./timesheet-entry.component.html",
  styleUrls: ["./timesheet-entry.component.css"],
})
export class TimesheetEntryComponent implements OnInit, OnDestroy {
  @ViewChild("lockedTimesheet") private lockedTimesheet: ElementRef;

  @SessionStorage() public user;
  @SessionStorage() public config;
  public timesheetConfig: TimeSheetEntry;
  public employeelistarr: any = []; // Array of Object of Employee working under logged RM is stored
  public userInfo: any; // Object to store the selected user details for timesheet entry
  public add_clicked: boolean = false; // Flag to check add Project or add Task is clicked
  public filteredEmpOptions: Observable<string[]>; // And Observable string array to store the filtered Employee List (Auto complete)
  public filteredTicketOptions: Observable<string[]>; // And Observable string array to store the filtered Employee List (Auto complete)
  public empName: string; // Variable to store the employee name selected from autocomplete
  public LeaveFlag: boolean = false; // Flag to check leave modal is opened or not
  public projectControl: FormControl[] = [];
  public firstDay: string;
  public lastDay: Date;
  public firstDayDate: string;
  public lastDayDate: string;
  public yearFirst: number;
  public yearLast: number;
  public currentDate: number;
  public currentDateDay: string;
  public currentYear: any;
  public projects: ProjectDetails[] = [];
  public weekNumber: any;
  public currentWeek: any;
  public weakTotal: any;
  public rejected: boolean = false;
  public tasktypeList: Array<any> = [];
  public targetIdList:Array<any>=[];
  public supportGroup: Array<any> = [];
  public taskList: Array<any> = [];
  public targetList:Array<any>=[];
  public projecttypeList: any = [];
  public ProjectWbscode:any=[];
  public allprojecttypeList: any = [];
  public allProjects:any=[];
  public uniqueProjects:any=[];
  public allProjectOptions:any=[];
  public selectedProject:any;
  public userDetails: any;
  public lockedData: any;
  public unlockRequest: boolean;
  public state: boolean;
  public employeeNo: number;
  public showTimesheet: boolean = true;
  public Leave: Array<any> = [];
  public timesheetIDs: Array<any> = [];
  public filteredOptions: any[];
  public selectedTargetIdList:any[];
  public filteredTargetIDOptions: string[] = [];
  public status: any;
  public approved: boolean = false;
  public unapproved: boolean = false;
  public submitted: boolean = false;
  public submitClicked: boolean = false;
  public isEmployee: boolean = false;
  public dayTotalInfo: Array<any> = [];
  public tickets: any = [];
  public dateDisplay: Array<any> = [];
  public dayTotal: Array<any> = [];
  public timeSheetEntryDate = new Date("02/07/2017"); //'MM/DD/YYYY'
  public project_invalid: boolean;
  public task_invalid: boolean = false;
  public isticketInvalid: boolean;
  public taskListFlag: boolean;
  public loaderFlag: boolean = false;
  public backupData: string = "";
  public dummydata = "";
  public focusData: boolean = false;
  public noTicket: boolean = false;
  public navigateDate: any;
  public timesheetStatus;
  public originalSize: number;
  public isLocked: boolean = false;
  public isAdherence: boolean = false;
  public isCompliance: boolean = false;
  public getPreviousWeekDate: any;
  public invalidFormatedData = false;
  private alive = true;
  public hasRM: any;
  public checkEmployeeRM: any;
  public isWeekend = false;
  public filteredActivityOptions: Observable<string[]>;
  public selectedData: any;
  public isReadOnly:Boolean=false;
  private isPopupVisible: boolean = false;
  private otherProjectSupport:boolean=false
  public hasBeenClicked: boolean = false;
  public searchText:string="";
  public metricsMap: { [key: string]: { stepsCompleted: number; reactionsPerformed: number; productiveReactions: number,successfulReactions:number} } = {};
  public dailyDates: string[] = [];

  public listOptions: any[] = [
    {
      groupName: "Projects",
    },
    {
      groupName: "Libaries",
    },
  ];
  constructor(
    public datePipe: DatePipe,
    public timesheetEntryService: TimesheetEntryService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private dashboardService: DashboardService,
    public timesheetApprovalService: TimesheetApprovalsService,
    private router: Router,
    private configService: ConfigService,
    public elRef: ElementRef
  ) {}

  ngOnInit() {
    this.employeeNo = this.user.Empno;
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    this.timesheetConfig = this.configService.getTimesheetConfig();
    const currentDay = new Date();
    this.currentDate = new Date().getDate();
    this.currentDateDay = this.currentDate + " " + days[new Date().getDay()];
    this.getCurrentWeek(currentDay);
    this.getPreviousWeekDate = this.currentWeek;
    this.getTasks();
    this.getProjectDetails();
    this.getLibaries();
    this.getSupport();
    if (this.config.businessUnit === "accenture") {
      this.weakTotal = 0;
    } else if (
      this.config.businessUnit === "ipdo" ||
      this.config.businessUnit === "biologics" ||
      this.config.businessUnit === "chinateam" ||
      this.config.businessUnit === "aps"
    ) {
      this.weakTotal = "00:00";
    }
    this.selectedData = this.listOptions[0].id;
    this.getEmployeeWeekTimesheet();
    this.checkEmployeeLockedStatus(null);
    this.dayTotalInfo = new Array(7).fill({ message: "", className: "" });
  }

  /**
   * @function getWeekDays
   * @description
   * Function to get the 7 days of the current week to be listed in the View
   * @param currentDate  the date from which the week date needs to calculated
   * @returns null
   * @callback getDateDay function to get the exact date with actual required format for the view purpose
   * @author gaurav.rao
   */
  getWeekDays(currentDate) {
    this.dateDisplay = [];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const curr = new Date(currentDate);
    let first;
    if (this.config.businessUnit === "accenture") {
      first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    } else {
      first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    }
    this.firstDay = new Date(curr.setDate(first)).toUTCString();
    const startDate = new Date(this.firstDay);
    this.lastDay = new Date(startDate.setDate(startDate.getDate() + 6));
    this.firstDayDate =
      new Date(this.firstDay).getDate() +
      " " +
      monthNames[new Date(this.firstDay).getMonth()];
    this.lastDayDate =
      new Date(this.lastDay).getDate() +
      " " +
      monthNames[new Date(this.lastDay).getMonth()];
    this.yearFirst = new Date(this.firstDay).getFullYear();
    this.yearLast = new Date(this.lastDay).getFullYear();
    // this.currentYear = this.yearLast;
    if (this.yearFirst == this.yearLast) {
      this.currentYear = this.yearLast;
    } else {
      this.currentYear = this.yearLast - 1;
    }
    this.weekNumber = this.datePipe.transform(startDate, "ww");
    if (this.config.businessUnit !== "accenture") {
      this.weekNumber = (this.weekNumber - 1).toString();
    }
    this.taskListFlag =
      new Date(
        this.datePipe.transform(this.firstDay, "yyyy-MM-dd")
      ).getTime() >= new Date("2018-04-01").getTime()
        ? true
        : false;
    /*Get all the 7 days date in the current week with respective flags */
    for (let i = 0; i < 7; i++) {
      this.getDateDay(i);
    }
  }

  /**function to get current week timesheet*/
  getCurrentWeek(currentDay) {
    let currDay;
    if (this.config.businessUnit !== "accenture" && currentDay.getDay() === 0) {
      currDay = new Date(currentDay);
      currDay.setDate(currentDay.getDate() - 1);
    } else {
      currDay = new Date(currentDay);
      currDay.setDate(currentDay.getDate());
    }
    const date = new Date(currDay);
    date.setDate(new Date(currDay).getDate());
    this.getWeekDays(date);
    this.currentWeek = this.datePipe.transform(date, "ww");
    this.weekNumber = this.datePipe.transform(date, "ww");
    if (this.currentWeek > 52) {
      this.currentWeek = 1;
    }
  }

  /**
   * @function getPreviousWeek
   * @description
   * Function to get the set of 7 days of the previous week and get the timesheet for the particular week
   * @requires firstDay the first date of the current Week in the view
   * @returns null
   * @callback getEmployeeTimesheet Getting the timesheet of the employee in that particular week
   * @callback getWeekDays Function to get the 7 days of the current week to be listed in the View
   * @author gaurav.rao
   */
  getPreviousWeek() {
    this.isReadOnly=false;
    // Checking the project entry date with first date of the week
    // console.log(this.firstDay,this.lastDay);
    if (this.timeSheetEntryDate.getTime() < new Date(this.firstDay).getTime()) {
      const date = new Date(this.firstDay);
      if (this.config.businessUnit === "accenture") {
        date.setDate(new Date(this.firstDay).getDate() - 2);
      } else {
        date.setDate(new Date(this.firstDay).getDate() - 3);
      }
      // date.setDate(new Date(this.firstDay).getDate() - 3); // Setting the date string to 3 days back from current Week
      this.getWeekDays(date);
      const previousWeekNumber = this.datePipe.transform(date, "ww"); // Date pipe to get the week number of the previous week
      this.getPreviousWeekDate = previousWeekNumber;
      // console.log(this.getPreviousWeekDate)
      this.getEmployeeTimesheet(previousWeekNumber, 0, "");
    }
  }

  /**
   * @function getNextWeek
   * @description
   * Function to get the set of 7days of the next week along with the timesheet of the particular week
   * @requires lastDay the last day of the current week in the view
   * @returns null
   * @callback getEmployeeTimesheet Getting the timesheet of the employee in that particular week
   * @callback getWeekDays Function to get the 7 days of the current week to be listed in the View
   * @author gaurav.rao
   */
  getNextWeek() {
    this.isReadOnly=false;
    // console.log(this.firstDay,this.lastDay);
    if (
      parseInt(this.weekNumber) !== parseInt(this.currentWeek) ||
      (parseInt(this.currentWeek) == 1 && parseInt(this.weekNumber) == 52) ||
      parseInt(this.weekNumber) == 1
    ) {
      const date = new Date(this.lastDay);
      date.setDate(new Date(this.lastDay).getDate() + 1);
      this.getWeekDays(date);
      let nextWeekNumber = this.datePipe.transform(date, "ww");
      // tslint:disable-next-line:radix
      if (parseInt(nextWeekNumber, 10) > 52) {
        nextWeekNumber = "0";
      }
      this.getPreviousWeekDate = nextWeekNumber;
      // console.log(this.getPreviousWeekDate)
      this.getEmployeeTimesheet(nextWeekNumber, 0, "");
    }
  }

  /**showTicketNumberFocus
   * @function getDateDay
   * @description
   * Function to get the exact date of the particular week by the "number" passed as argument. Number =0 means Sunday,6= Saturday
   * The weekDay along with the Date will be stored with few flag to set the activeness of the timesheet input box
   * @param number the count to be added to the firstDay 0= date for sunday 6 = count for saturday
   * @requires DateDisplay Class Object with Day, date, flag detials of the particular date
   * @var disableTimeSheetEntry A boolean flag for checking condtion for the entry date of the timesheet
   * @var flag A boolean flag set to maintain the future date to be disabled in timesheet input
   * @author gaurav.rao
   */
  getDateDay(number) {
    const getDate = new DateDisplay();
    let days;
    if (this.config.businessUnit === "accenture") {
      days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    } else {
      days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    }
    getDate.day = days[number];
    const date = new Date(this.firstDay);
    date.setDate(date.getDate() + number);
    if (date.getTime() > new Date().getTime()) {
      getDate.flag = false;
    }
    if (this.timeSheetEntryDate.getTime() >= date.getTime()) {
      getDate.disableTimeSheetEntry = true;
    }
    getDate.date = date.getDate();
    this.dateDisplay.push(getDate);
  }

  /**function to add task */
  addtask(k, i, valid) {
    if (this.projects[i].task[k].taskType !== "") {
      if (this.config.businessUnit === "accenture") {
        const newTask = new TaskDetailsAccenture("", " ", this.firstDay);
        this.projects[i].task.push(newTask);
      } else if (
        this.config.businessUnit === "ipdo" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        const newTask = new TaskDetails("", " ", this.firstDay);
        this.projects[i].task.push(newTask);
      } else if (this.config.businessUnit === "biologics") {
        const newTask = new TaskDetailsBiologics("", " ", this.firstDay);
        this.projects[i].task.push(newTask);
      }
      // for (let m = 0; m < 7; m++) {
      //   this.projects[i].task[this.projects[i].task.length - 1].WeakDetails[m].status = this.projects[0].task[0].WeakDetails[m].status;
      // }
    }
    if (this.lockedData.isLocked) {
      this.lockedData.lockedDateDetails.forEach((element, j) => {
        const l = k + 1;
        for (let m = 0; m < 7; m++) {
          const lockedDateString = new Date(
            this.lockedData.lockedDateDetails[j]
          );
          const lockedDate = new Date(
            lockedDateString.getFullYear(),
            lockedDateString.getMonth(),
            lockedDateString.getDate()
          ).getTime();
          const timesheetDateString = new Date(
            this.projects[i].task[l].weak[m]
          );
          const timesheetDate = new Date(
            timesheetDateString.getFullYear(),
            timesheetDateString.getMonth(),
            timesheetDateString.getDate()
          ).getTime();
          if (lockedDate == timesheetDate) {
            this.projects[i].task[l].locked[m] = m;
          }
        }
      });
    }
  }

  /**function to remove project and task */
  remove(i, j, data, taskDetails) {
    let weakTimesheetTotal = 0;
    if (this.checkRowList(data)) {
      this.projects[j].taskList.forEach((ele, k) => {
        if (ele.activityType == taskDetails) {
          this.projects[j].taskList[k].selectedFlag = false;
        }
      });
      if (this.projects[j].task.length == 1) {
        if (
          this.config.businessUnit == "ipdo" ||
          this.config.businessUnit == "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          this.dayTotal = new Array(7).fill("00:00");
        } else if (this.config.businessUnit == "accenture") {
          this.dayTotal = new Array(7).fill(0);
        }
        const daytimesheetTotal = new Array(7).fill(0);
        if (
          this.projects[j].projectName == "" ||
          data.filter((t) => t.FilledHrs != "00:00").length == 0
        ) {
          this.projects.splice(j, 1);
        }
        this.projects.forEach((ele, p) => {
          ele.task.forEach((element, t) => {
            for (let d = 0; d < 7; d++) {
              if (
                this.config.businessUnit == "ipdo" ||
                this.config.businessUnit == "biologics" ||
                this.config.businessUnit === "chinateam" ||
                this.config.businessUnit === "aps"
              ) {
                if (p === j) {
                  this.projects[p].task[t].WeakDetails[d].FilledHrs = "00:00";
                }
                daytimesheetTotal[d] += this.convertHoursToMins(
                  this.projects[p].task[t].WeakDetails[d].FilledHrs
                );
                this.dayTotal[d] = this.convertMinsToHrsMins(
                  daytimesheetTotal[d]
                );
              } else if (this.config.businessUnit == "accenture") {
                this.dayTotal[d] += Number(
                  this.projects[p].task[t].WeakDetails[d].FilledHrs
                );
              }
            }
          });
        });
        if (
          this.config.businessUnit == "ipdo" ||
          this.config.businessUnit == "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          for (let x = 0; x < this.dayTotal.length; x++) {
            weakTimesheetTotal += this.convertHoursToMins(this.dayTotal[x]);
            this.weakTotal = this.convertMinsToHrsMins(weakTimesheetTotal);
          }
        } else if (this.config.businessUnit == "accenture") {
          this.weakTotal = this.dayTotal
            .reduce((a, b) => {
              return a + b;
            }, 0)
            .toPrecision(3);
        }
      } else if (this.projects[j].task.length > 1) {
        if (
          this.config.businessUnit == "ipdo" ||
          this.config.businessUnit == "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          this.dayTotal = new Array(7).fill("00:00");
        } else if (this.config.businessUnit == "accenture") {
          this.dayTotal = new Array(7).fill(0);
        }
        const daytimesheetTotal = new Array(7).fill(0);

        if (this.projects[j].task[i].taskType == "") {
          this.projects[j].task.splice(i, 1);
        }

        this.projects.forEach((ele, p) => {
          ele.task.forEach((element, t) => {
            for (let d = 0; d < 7; d++) {
              if (
                this.config.businessUnit === "ipdo" ||
                this.config.businessUnit == "biologics" ||
                this.config.businessUnit === "chinateam" ||
                this.config.businessUnit === "aps"
              ) {
                if (p === j && t === i) {
                  this.projects[p].task[t].WeakDetails[d].FilledHrs = "00:00";
                }
                daytimesheetTotal[d] += this.convertHoursToMins(
                  this.projects[p].task[t].WeakDetails[d].FilledHrs
                );
                this.dayTotal[d] = this.convertMinsToHrsMins(
                  daytimesheetTotal[d]
                );
              } else if (this.config.businessUnit === "accenture") {
                this.dayTotal[d] += Number(
                  this.projects[p].task[t].WeakDetails[d].FilledHrs
                );
              }
            }
          });
        });
        if (
          this.config.businessUnit == "ipdo" ||
          this.config.businessUnit == "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          for (let x = 0; x < this.dayTotal.length; x++) {
            weakTimesheetTotal += this.convertHoursToMins(this.dayTotal[x]);
            this.weakTotal = this.convertMinsToHrsMins(weakTimesheetTotal);
          }
        } else if (this.config.businessUnit == "accenture") {
          this.weakTotal = this.dayTotal
            .reduce((a, b) => {
              return a + b;
            }, 0)
            .toPrecision(3);
        }
      }

      if (this.projects[j] && this.projects[j].task[i]) {
        var dailyMetrics = this.dateDisplay.map(day => ({
          date:day.date,
          stepsCompleted: day.steps,
          reactionsPerformed: day.reactions,
          productiveReactions: day.productiveReactions,
          successfulReactions:day.successfulReactions
        }));
        this.timesheetEntryService
          .saveEmployeeAsDraftProjectDetails(
            this.projects,
            this.userDetails,
            this.weekNumber,
            this.currentYear,
            this.Leave,
            this.timesheetIDs,
            dailyMetrics
          )
          .subscribe(
            (data) => {
              this.loaderFlag = false;
              this.dayTotalInfo = new Array(7).fill({
                message: "",
                className: "",
              });
              this.snackBar.open("Timesheet deleted successfully", "OK", {
                duration: 5000,
              });
              this.getEmployeeTimesheet(this.weekNumber, 0, "");
            },
            (error) => {
              this.submitClicked = false;
              this.loaderFlag = false;
              this.validateEnteredInput();

              if (!!error.error) {
                this.snackBar.open(error.error.message, "OK", {
                  duration: 5000,
                });
              } else {
                this.snackBar.open(error, "OK", {
                  duration: 5000,
                });
              }
            }
          );
      }
    }
  }

  /**function to check row data */
  checkRowList(data) {
    let flag = true;
    for (let i = 1; i <= 5; i++) {
      if (data[i].status == "0" || data[i].status == 2) {
        flag = false;
      }
    }
    return flag;
  }

  /**function to get project details */
  getProjectDetails() {
    this.otherProjectSupport=false;
    this.timesheetEntryService.getProjectList(this.otherProjectSupport).subscribe((data) => {
      data.payload.forEach((value) => {
        if (value.project_id) {
          this.projecttypeList.push(new DropDownProject(value));
          this.ProjectWbscode.push(value.wbs_code);
        }
      });
      this.getTargetIds();
    });
    this.listOptions[0].groups = this.projecttypeList;
  }

  getProjectDetailsForOtherProjectSupport(otherProjectSupport) {
    this.timesheetEntryService.getProjectList(otherProjectSupport).subscribe((data) => {
      data.payload.forEach((value) => {
          this.allProjects.push(new DropDownProject(value));
          this.allprojecttypeList.push(new DropDownProject(value))
      });
    });
  }
  /**function to get library */
  getLibaries() {
    this.timesheetEntryService.getLibriesList().subscribe((data) => {
      this.listOptions[1].groups = data.payload;
    });
  }

  /**function to get tasks */
  getTasks() {
    this.timesheetEntryService.getTaskList().subscribe((data) => {
      if (
        this.config.businessUnit == "ipdo" ||
        this.config.businessUnit == "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        data.payload.forEach((value) => {
          this.tasktypeList.push(new DropDownTask(value));
        });
      } else {
        data.payload.forEach((value) => {
          this.tasktypeList.push(new NonIPDODropDownTask(value));
        });
      }
      this.taskList = this.tasktypeList;

      if (this.navigateDate === undefined) {
        setTimeout(
          function (self) {
            self.getEmployeeTimesheet(self.currentWeek, 0, "");
          },
          1000,
          this
        );
      }
    });
  }

   getTargetIds() {
    if (this.projecttypeList && this.projecttypeList.length > 0) {
      // Extract the wbscode from the first project
      const wbscode = this.projecttypeList[0].wbscode;
      console.log('Extracted wbscode:', wbscode);
    }
    this.timesheetEntryService.getTargetIds(this.ProjectWbscode).subscribe((data) => {
    if (
        this.config.businessUnit == "ipdo" ||
        this.config.businessUnit == "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        data.payload.map((value) =>
          this.targetIdList.push(new DropDownTargetId(value))
        );
      }
      this.targetList = JSON.parse(JSON.stringify(this.targetIdList));
      if (this.navigateDate === undefined) {
        setTimeout(
          (self) => {
            self.getEmployeeTimesheet(self.currentWeek, 0);
          },
          1000,
          this
        );
      }
    });
  }
  /**function to get support data */
  getSupport() {
    this.timesheetEntryService.getSupportGroup().subscribe((data) => {
      if (this.config.businessUnit === "accenture") {
        this.supportGroup = data.payload;
      }
    });
  }

  /**function to get timesheet based on weeknumber*/
  getEmployeeTimesheet(currentWeek, getPreviousProject, where) {
    // console.log(currentWeek,getPreviousProject)
    this.loaderFlag = true;
    this.submitted = false;
    this.Leave = [];
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    this.projects = [];
    this.Leave = [];
    this.rejected = false;
    this.approved = false;
    this.unapproved = false;
    for (let i = 0; i < 7; i++) {
      this.Leave.push(new Leave(days[i]));
    }
    // console.log(currentWeek, this.currentYear, getPreviousProject);
    // if (currentWeek == 0 && this.currentYear == 2022) {
    //   // this is for dec 2022 to november 2023 only.
    //   currentWeek = 52;
    // }
    // currentWeek == 52 ? (this.currentYear = 2022) : false; // this is for dec 2021 to november 2022 only.
    console.log(currentWeek, this.currentYear, getPreviousProject);
    this.timesheetEntryService
      .getEmployeeProjectDetails(
        (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
        this.datePipe.transform(this.firstDay, "ww") == "53")?1:currentWeek,
        this.employeeNo,
        (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")?this.currentYear+1:this.currentYear,
        getPreviousProject
      )
      .pipe(takeWhile(() => this.alive))
      .subscribe(
        (data) => {
          if (data.payload.dailyMetrics && this.dateDisplay && this.dateDisplay.length > 0) {
            data.payload.dailyMetrics.forEach(metric => {
              // Extract the day of the month from the metric's date
              const metricDay = new Date(metric.dateDetails.date).getDate();
              // Find the matching day object in dateDisplay (which is bound to your input boxes)
              const dayObj = this.dateDisplay.find(day => day.date === metricDay);
              if (dayObj) {
                // Assign API values to the corresponding properties.
                dayObj.steps = metric.stepsCompleted ? metric.stepsCompleted.toString() : dayObj.steps;
                dayObj.reactions = metric.reactionsPerformed ? metric.reactionsPerformed.toString() : dayObj.reactions;
                dayObj.productiveReactions = metric.productiveReactions ? metric.productiveReactions.toString() : dayObj.productiveReactions;
                dayObj.successfulReactions=metric.successfulReactions?metric.successfulReactions.toString():dayObj.successfulReactions;
              }
            });
          }
          this.loaderFlag = false;
          this.timesheetIDs = [];
          this.projects = [];
          if (
            this.config.businessUnit == "ipdo" ||
            this.config.businessUnit == "biologics" ||
            this.config.businessUnit === "chinateam" ||
            this.config.businessUnit === "aps"
          ) {
            this.dayTotalInfo = new Array(7).fill({
              message: "",
              className: "",
            });
            this.dayTotal = new Array(7).fill("00:00");
            this.weakTotal = "00:00";
          } else if (this.config.businessUnit == "accenture") {
            this.dayTotal = new Array(7).fill(0);
            this.weakTotal = 0;
          }
          const totalTimesheetData = new Array(7).fill(0);
          this.userDetails = data.payload.userDetails;
          this.status = data.payload.approvalStatus;

          if (this.status) {
            this.rejected = this.status.status == 1 ? true : false;
            this.approved = this.status.status == 2 ? true : false;
            this.unapproved = this.status.status == "0" ? true : false;
            // this.unapproved = this.status.status == '' ? true : false;
          }

          if (
            data.payload &&
            data.payload.projectDetails &&
            data.payload.projectDetails.length != 0
          ) {
            data.payload.projectDetails.forEach((value) => {
              this.projects.push(
                new ProjectDetails(
                  value,
                  this.status.status,
                  "",
                  this.taskList,
                  this.config.businessUnit,
                  where
                )
              );
            });
            for (let p = 0; p < this.projects.length; p++) {
              for (let t = 0; t < this.projects[p].task.length; t++) {
                for (let i = 0; i < 7; i++) {
                  if (this.config.businessUnit == "accenture") {
                    this.dayTotal[i] += Number(
                      this.projects[p].task[t].WeakDetails[i].FilledHrs
                    );
                  } else if (
                    this.config.businessUnit == "ipdo" ||
                    this.config.businessUnit == "biologics" ||
                    this.config.businessUnit === "chinateam" ||
                    this.config.businessUnit === "aps"
                  ) {
                    totalTimesheetData[i] += this.convertHoursToMins(
                      this.projects[p].task[t].WeakDetails[i].FilledHrs
                    );
                    this.dayTotal[i] = this.convertMinsToHrsMins(
                      totalTimesheetData[i]
                    );
                  }
                  if (
                    this.projects[p].task[t].WeakDetails[i].status == "0" ||
                    this.projects[p].task[t].WeakDetails[i].status == 2
                  ) {
                    this.Leave[i].active = false;
                  }
                  if (
                    (this.projects[p].task[t].WeakDetails[i].status == "" ||
                      this.projects[p].task[t].WeakDetails[i].status == 1) &&
                    this.taskListFlag
                  ) {
                    if (
                      this.config.businessUnit == "ipdo" ||
                      this.config.businessUnit == "biologics" ||
                      this.config.businessUnit === "chinateam" ||
                      this.config.businessUnit === "aps"
                    ) {
                      if (this.projects[p].projectName == "Functional") {
                        this.projects[p].taskList = this.taskList.filter(
                          (entity) => entity.activityFlag == false
                        );
                      } else {
                        this.projects[p].taskList = this.taskList.filter(
                          (entity) => entity.activityFlag == true
                        );
                      }
                    } else {
                      this.projects[p].taskList = this.taskList.filter(
                        (entity) => entity.activityFlag == true
                      );
                    }
                  }
                }
              }
            }
            if (
              this.config.businessUnit == "ipdo" ||
              this.config.businessUnit == "biologics" ||
              this.config.businessUnit === "chinateam" ||
              this.config.businessUnit === "aps"
            ) {
              let weekTotalData = 0;
              for (let x = 0; x < this.dayTotal.length; x++) {
                weekTotalData += this.convertHoursToMins(this.dayTotal[x]);
                this.weakTotal = this.convertMinsToHrsMins(weekTotalData);
              }
            } else if (this.config.businessUnit == "accenture") {
              this.weakTotal = this.dayTotal
                .reduce((a, b) => {
                  return a + b;
                }, 0)
                .toPrecision(3);
            }
          } else {
            this.projects.push(
              new ProjectDetails(
                "",
                "",
                this.firstDay,
                this.taskList,
                this.config.businessUnit,
                where
              )
            );
            if (
              data.payload.projectDetails.length === 0 &&
              getPreviousProject === 1
            ) {
              this.snackBar.open(
                "Previous Week Timesheet entry is empty",
                "OK",
                {
                  duration: 5000,
                }
              );
            }
          }
          if (data.payload["leaveDetails"]) {
            const leaveDetails = data.payload.leaveDetails["dates"]
              ? data.payload.leaveDetails["dates"]
              : [];
            leaveDetails.forEach((leave) => {
              for (let j = 0; j < 7; j++) {
                this.projects.forEach((project) => {
                  project.task.forEach((task) => {
                    if (
                      task.weak[j].getDate() ===
                        new Date(leave.date).getDate() &&
                      task.weak[j].getMonth() + 1 ===
                        new Date(leave.date).getMonth() + 1 &&
                      task.weak[j].getFullYear() ===
                        new Date(leave.date).getFullYear()
                    ) {
                      task.WeakDetails[j].leaveApplied = true;
                    }
                  });
                });
              }
            });
          }
          // const leaveDetails = data.payload.leaveDetails ? data.payload.leaveDetails : [];
          // leaveDetails.forEach(leave => {
          //   for (let j = 0; j < 7; j++) {
          //     if (this.projects[0].task[0].weak[j].getDate() == new Date(leave.dateDetails.date).getDate() && leave.leaveType != "") {
          //       this.Leave[j].leaveType = leave.leaveType;
          //       if (leave.approvalStatus.status == "0" || leave.approvalStatus.status == 2) {
          //         this.Leave[j].active = false;
          //       }
          //       for (let p = 0; p < this.projects.length; p++) {
          //         for (let t = 0; t < this.projects[p].task.length; t++) {
          //           this.projects[p].task[t].WeakDetails[j].status = "0";
          //         }
          //       }
          //       break;
          //     }
          //   }
          // });
          const timesheetIDs = data.payload.timesheetIDs
            ? data.payload.timesheetIDs
            : [];
          timesheetIDs.forEach((timeid) => {
            for (let j = 0; j < 7; j++) {
          //     if (
          //       this.projects[0].task[0].weak[j].getDate() ==
          //       new Date(timeid.dateDetails.date).getDate()
          //     ) {
          //       this.timesheetIDs[j] = timeid;
          //       break;
          //     }
          //   }
          // });
           // Convert this.projects[0].task[0].weak[j] to Indian time zone
           var indianDate = new Date(this.projects[0].task[0].weak[j].toISOString().slice(0, 10) + 'T00:00:00.000Z');
           indianDate.setUTCHours(5); // Setting time to 5:30 AM (Indian Standard Time)

           // Convert timeid.dateDetails.date to Indian time zone and extract the day of the month as a number
           var timeidDate = new Date(timeid.dateDetails.date);
           var timeidDay = new Date(timeidDate.toLocaleString('en-US', {timeZone: 'Asia/Kolkata'})).getDate();

           // Compare dates in the same time zone
           if (indianDate.getDate() === timeidDay) {
               this.timesheetIDs[j] = timeid;
               break;
           }
       }
});
          this.lockedData = data.payload.lockedDetails
            ? data.payload.lockedDetails
            : [];
          if (this.lockedData.isLocked) {
            this.lockedData.lockedDateDetails.forEach((element, j) => {
              for (var m = 0; m < this.projects.length; m++) {
                if (this.projects[m].task) {
                  for (let i = 0; i < this.projects[m].task.length; i++) {
                    for (let k = 0; k < 7; k++) {
                      const lockedDateString = new Date(
                        this.lockedData.lockedDateDetails[j]
                      );
                      const lockedDate = new Date(
                        lockedDateString.getFullYear(),
                        lockedDateString.getMonth(),
                        lockedDateString.getDate()
                      ).getTime();
                      const timesheetDateString = new Date(
                        this.projects[m].task[i].weak[k]
                      );
                      const timesheetDate = new Date(
                        timesheetDateString.getFullYear(),
                        timesheetDateString.getMonth(),
                        timesheetDateString.getDate()
                      ).getTime();
                      if (lockedDate == timesheetDate) {
                        this.projects[m].task[i].locked[k] = k;
                        this.Leave[k].active = false;
                      }
                    }
                  }
                }
              }
            });
          }
        },
        (err) => {
          this.loaderFlag = false;
        }
      );
  }

  /**function to open leave popup*/
  openLeavePopUp(i) {
    this.Leave[i].flag = true;
    this.LeaveFlag = true;
  }



  // hasTargetIDSelected(dayIndex: number): boolean {
  //   // Check if any project has a targetID selected for the given day
  //   return this.projects.some(project =>
  //     project.task.some(task =>
  //       task.targetID &&  // Check if targetID exists
  //       task.WeakDetails[dayIndex].FilledHrs &&
  //       task.WeakDetails[dayIndex].FilledHrs !== '00:00'
  //     )
  //   );
  // }

  preventTyping(event: KeyboardEvent) {
    // Allow only navigation keys (arrows, tab, etc.)
    const allowedKeys = [
      'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
      'Tab', 'Enter', 'Escape', 'Backspace', 'Delete'
    ];

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  hasTargetIDSelected(dayIndex: number): boolean {
    return this.projects.some(project => {
        return project.task.some(task => {
            return task.targetID && task.WeakDetails && task.WeakDetails[dayIndex] && task.WeakDetails[dayIndex].FilledHrs && task.WeakDetails[dayIndex].FilledHrs !== '00:00';
        });
    });
}

  validateDailyMetrics(dayIndex: number): boolean {
    // Check if any project has targetID and hours for this day
    const hasTargetIDEntry = this.projects.some(project =>
      project.task.some(task =>
        task.targetID &&  // Check if targetID exists
        task.WeakDetails[dayIndex].FilledHrs &&
        task.WeakDetails[dayIndex].FilledHrs !== '00:00'
      )
    );

    if (hasTargetIDEntry) {
      // If there's a targetID entry, verify metrics are filled
      const day = this.dateDisplay[dayIndex];
      if (!day.reactions || !day.steps || !day.productiveReactions || !day.successfulReactions) {
        this.snackBar.open(
          `Please fill in reactions, steps,productive reactions and successfulReactions  for ${day.day} where targetID is entered`,
          "OK",
          { duration: 5000 }
        );
        return false;
      }
    }
    return true;
  }
  /**function to check/validate half day*/
  halfDay(day) {
    this.LeaveFlag = false;
    for (let i = 1; i <= 5; i++) {
      if (day == i) {
        this.Leave[i].leaveType = "halfDay";
        this.Leave[i].type = "halfDay";
        this.Leave[i].flag = false;
        this.Leave[i].value = 4;
      }
    }
  }

  /**function to check/validate fullday*/
  fullDay(day) {
    this.LeaveFlag = false;
    this.rejected = false;
    this.approved = false;
    this.unapproved = false;
    for (let k = 0; k < this.projects.length; k++) {
      if (this.projects[k].task.length > 0) {
        for (let j = 0; j < this.projects[k].task.length; j++) {
          this.projects[k].task[j].WeakDetails[day].FilledHrs = 0;
          this.projects[k].task[j].WeakDetails[day].status = "0";
        }
      }
    }
    this.dayTotal[day] = 0;
    this.Leave[day].leaveType = "fullDay";
    this.Leave[day].type = "fullDay";
    this.Leave[day].flag = false;
    this.Leave[day].value = 23.5;
  }

  /**function to clear day*/
  clearDay(day) {
    this.LeaveFlag = false;
    for (let k = 0; k < this.projects.length; k++) {
      if (this.projects[k].task.length > 0) {
        for (let j = 0; j < this.projects[k].task.length; j++) {
          this.projects[k].task[j].WeakDetails[day].FilledHrs = 0;
          this.projects[k].task[j].WeakDetails[day].status = "";
        }
      }
    }
    this.dayTotal[day] = 0;
    this.Leave[day].leaveType = "";
    this.Leave[day].flag = false;
    this.Leave[day].value = 0;
  }

  /**function to add project*/
  addProject(timeForm) {
    this.isReadOnly=false;
    this.submitted = false;
    this.add_clicked = true;
    this.allProjectOptions=[];
    if (this.projects.length == 0) {
      this.state = false;
      this.projects.push(
        new ProjectDetails(
          "",
          " ",
          this.firstDay,
          this.taskList,
          this.config.businessUnit
        )
      );
      this.projects[this.projects.length - 1].taskList = this.tasktypeList;
      this.projectControl[this.projects.length - 1] = new FormControl();
    } else if (this.projects.length != 0) {
      const index = this.projects[this.projects.length - 1].task.length;
      if (this.projects[this.projects.length - 1].projectName == "") {
        this.add_clicked = true;
        this.state = true;
      } else {
        this.state = true;
        let taskControlsData = Object.keys(timeForm.controls).filter((task) =>
          task.startsWith("task")
        );

        taskControlsData.forEach((task) => {
          const taskControl = timeForm.controls[task];
          const validators =
            taskControl.validator && taskControl.validator({} as FormControl);
          const newValidators = validators ? validators : [];
          taskControl.setValidators(newValidators);
          taskControl.updateValueAndValidity();
        });
        if (timeForm.valid) {
          this.state = false;
          this.add_clicked = false;
          this.projects.push(
            new ProjectDetails(
              "",
              " ",
              this.firstDay,
              this.tasktypeList,
              this.config.businessUnit
            )
          );
          this.projectControl[this.projects.length - 1] = new FormControl();
          this.projects[this.projects.length - 1].taskList = this.tasktypeList;
          // for (let m = 0; m < 7; m++) {
          //   this.projects[this.projects.length - 1].task[0].WeakDetails[m].status = this.projects[0].task[0].WeakDetails[m].status;
          // }
        }
      }
      if (this.lockedData.isLocked) {
        this.lockedData.lockedDateDetails.forEach((element, j) => {
          for (let k = 0; k < 7; k++) {
            const lockedDateString = new Date(
              this.lockedData.lockedDateDetails[j]
            );
            const lockedDate = new Date(
              lockedDateString.getFullYear(),
              lockedDateString.getMonth(),
              lockedDateString.getDate()
            ).getTime();
            const timesheetDateString = new Date(
              this.projects[0].task[0].weak[k]
            );
            const timesheetDate = new Date(
              timesheetDateString.getFullYear(),
              timesheetDateString.getMonth(),
              timesheetDateString.getDate()
            ).getTime();
            if (lockedDate == timesheetDate) {
              this.projects[this.projects.length - 1].task[0].locked[k] = k;
            }
          }
        });
      }
    }
  }

  /**function to validate hour*/
  checkValidHour(event, i, j, d) {
    this.invalidFormatedData = false;
    const checkTimeFormat =
      this.projects[i].task[j].WeakDetails[d].FilledHrs.split(":");
    if (checkTimeFormat[0].length === 1) {
      checkTimeFormat[0] = "0" + checkTimeFormat[0];
    } else if (
      checkTimeFormat[0] === undefined ||
      checkTimeFormat[0] === "" ||
      checkTimeFormat[0] === "0000" ||
      checkTimeFormat[0] === "000"
    ) {
      checkTimeFormat[0] = "00";
    }
    if (checkTimeFormat[1] && checkTimeFormat[1].length === 1) {
      checkTimeFormat[1] = "0" + checkTimeFormat[1];
    } else if (checkTimeFormat[1] === undefined || checkTimeFormat[1] === "") {
      checkTimeFormat[1] = "00";
    }
    this.projects[i].task[j].WeakDetails[d].FilledHrs =
      checkTimeFormat[0] + ":" + checkTimeFormat[1];
    if (this.projects[i].task[j].WeakDetails[d].FilledHrs !== "00:00") {
      const pattern = /^(?:[0-2][0-9]):[0-5][0-9]$/;
      if (
        this.projects[i].task[j].WeakDetails[d].FilledHrs === "0:00" ||
        this.projects[i].task[j].WeakDetails[d].FilledHrs === "00:0"
      ) {
        this.projects[i].task[j].WeakDetails[d].FilledHrs = "00:00";
      }
      if (pattern.test(this.projects[i].task[j].WeakDetails[d].FilledHrs)) {
        this.projects[i].task[j].WeakDetails[d].valid = true;
      } else {
        this.projects[i].task[j].WeakDetails[d].valid = false;
        this.invalidFormatedData = true;
        const invalidTime =
          this.projects[i].task[j].WeakDetails[d].FilledHrs.split(":");
        const hrs = invalidTime[0] === "00" ? true : !!Number(invalidTime[0]);
        const mins = invalidTime[1] === "00" ? true : !!Number(invalidTime[1]);
        if (!!hrs && !!mins) {
          const countHr = Number(invalidTime[0]);
          const countMin = Number(invalidTime[1]);
          if (countHr > 23) {
            // const data = { message: 'Field Hours should not be more than 23 hours' };
            // if (this.dialog.openDialogs.length === 0) {
            //   const dialogRef = this.dialog.open(ErrorPopUpComponent, {
            //     width: '320px',
            //     data: data
            //   });
            //   dialogRef.afterClosed().subscribe(result => {
            //     if (result === true) {
            //     }
            //   });
            // }
          } else if (countMin > 59) {
            invalidTime[1] = "59";
            this.projects[i].task[j].WeakDetails[d].FilledHrs =
              invalidTime[0] + ":" + invalidTime[1];
            this.projects[i].task[j].WeakDetails[d].valid = true;
            this.invalidFormatedData = false;
          }
        } else {
          const data = { message: "Please check the format" };
          if (this.dialog.openDialogs.length === 0) {
            const dialogRef = this.dialog.open(ErrorPopUpComponent, {
              width: "320px",
              data: data,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result === true) {
              }
            });
          }
        }
      }
    }
    let totalWeekValue = 0;
    let totalTimesheetValue = 0;
    let totalTimesheetData = 0;
    for (let k = 0; k < 7; k++) {
      totalWeekValue += this.convertHoursToMins(
        this.projects[i].task[j].WeakDetails[k].FilledHrs
      );
      this.projects[i].task[j].total =
        this.convertMinsToHrsMins(totalWeekValue);
    }
    this.projects.forEach((ele, p) => {
      ele.task.forEach((element, t) => {
        totalTimesheetValue += this.convertHoursToMins(
          this.projects[p].task[t].WeakDetails[d].FilledHrs
        );
        this.dayTotal[d] = this.convertMinsToHrsMins(totalTimesheetValue);
      });
    });
    for (let x = 0; x < this.dayTotal.length; x++) {
      totalTimesheetData += this.convertHoursToMins(this.dayTotal[x]);
      this.weakTotal = this.convertMinsToHrsMins(totalTimesheetData);
    }
  }

  /**function to event bubble key*/
  isNumberKey(evt) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (
      (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) ||
      charCode === 46
    ) {
      evt.preventDefault();
    }
  }

  /**function to change total*/
  changeTotal(i, j, d) {
    if (
      this.config.businessUnit === "ipdo" ||
      this.config.businessUnit == "biologics" ||
      this.config.businessUnit === "aps"
    ) {
      if (this.projects[i].task[j].WeakDetails[d].FilledHrs !== "") {
        if (this.projects[i].task[j].WeakDetails[d].FilledHrs.length === 2) {
          this.projects[i].task[j].WeakDetails[d].FilledHrs =
            this.projects[i].task[j].WeakDetails[d].FilledHrs + ":" + "00";
        } else if (
          this.projects[i].task[j].WeakDetails[d].FilledHrs.length === 1 &&
          this.projects[i].task[j].WeakDetails[d].FilledHrs <= 9
        ) {
          this.projects[i].task[j].WeakDetails[d].FilledHrs =
            "0" + this.projects[i].task[j].WeakDetails[d].FilledHrs + ":00";
        }
      } else {
        this.projects[i].task[j].WeakDetails[d].FilledHrs = "00:00";
      }
    }
    if (this.config.businessUnit === "chinateam") {
      if (this.projects[i].task[j].WeakDetails[d].FilledHrs !== "") {
        if (this.projects[i].task[j].WeakDetails[d].FilledHrs.length === 2) {
          this.projects[i].task[j].WeakDetails[d].FilledHrs =
            this.projects[i].task[j].WeakDetails[d].FilledHrs + ":" + "00";
        } else if (
          this.projects[i].task[j].WeakDetails[d].FilledHrs.length === 1 &&
          this.projects[i].task[j].WeakDetails[d].FilledHrs <= 1
        ) {
          this.projects[i].task[j].WeakDetails[d].FilledHrs =
            "0" + this.projects[i].task[j].WeakDetails[d].FilledHrs + ":00";
        }
      } else {
        this.projects[i].task[j].WeakDetails[d].FilledHrs = "00:00";
      }
    }
    this.approved = false;
    this.unapproved = false;
    this.submitClicked = false;
    if (
      this.config.businessUnit === "ipdo" ||
      this.config.businessUnit == "biologics" ||
      this.config.businessUnit === "chinateam" ||
      this.config.businessUnit === "aps"
    ) {
      this.dayTotal[d] = "00:00";
      this.projects[i].task[j].total = "00:00";
      if (this.projects[i].task[j].WeakDetails[d].FilledHrs === "") {
        this.projects[i].task[j].WeakDetails[d].FilledHrs = "00:00";
      }
    } else if (this.config.businessUnit === "accenture") {
      this.dayTotal[d] = 0;
      this.projects[i].task[j].total = 0;
    }
    let totalWeekValue = 0;
    let totalTimesheetValue = 0;
    let totalTimesheetData = 0;

    for (let k = 0; k < 7; k++) {
      if (this.config.businessUnit === "accenture") {
        this.projects[i].task[j].total += Number(
          this.projects[i].task[j].WeakDetails[k].FilledHrs
        );
      } else if (
        this.config.businessUnit === "ipdo" ||
        this.config.businessUnit == "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        totalWeekValue += this.convertHoursToMins(
          this.projects[i].task[j].WeakDetails[k].FilledHrs
        );
        this.projects[i].task[j].total =
          this.convertMinsToHrsMins(totalWeekValue);
      }
    }

    this.projects.forEach((ele, p) => {
      ele.task.forEach((element, t) => {
        if (
          this.config.businessUnit === "ipdo" ||
          this.config.businessUnit == "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          totalTimesheetValue += this.convertHoursToMins(
            this.projects[p].task[t].WeakDetails[d].FilledHrs
          );
          this.dayTotal[d] = this.convertMinsToHrsMins(totalTimesheetValue);
        } else if (this.config.businessUnit === "accenture") {
          this.dayTotal[d] += Number(
            this.projects[p].task[t].WeakDetails[d].FilledHrs
          );
        }
      });
    });

    if (
      this.config.businessUnit === "ipdo" ||
      this.config.businessUnit == "biologics" ||
      this.config.businessUnit === "chinateam" ||
      this.config.businessUnit === "aps"
    ) {
      for (let x = 0; x < this.dayTotal.length; x++) {
        totalTimesheetData += this.convertHoursToMins(this.dayTotal[x]);
        this.weakTotal = this.convertMinsToHrsMins(totalTimesheetData);
      }
    } else if (this.config.businessUnit === "accenture") {
      this.weakTotal = this.dayTotal
        .reduce((a, b) => {
          return a + b;
        }, 0)
        .toPrecision(3);
    }
  }

  /**function to show error focus on input */
  validateEnteredInput() {
    for (let j = 0; j < 7; j++) {
      this.projects.forEach((project) => {
        project.task.forEach((task) => {
          const errorDay =
            task.WeakDetails[j].day.charAt(0).toUpperCase() +
            task.WeakDetails[j].day.slice(1);

          const hms = this.dayTotal[j]; // your input string
          const a = hms.split(":"); // split it at the colons
          // minutes are worth 60 seconds. Hours are worth 60 minutes.
          const taskInSeconds = +a[0] * 60 * 60 + +a[1] * 60;
          // if (
          //   taskInSeconds < 3600 &&
          //   taskInSeconds !== 0 &&
          //   task.WeakDetails[j].status !== "0" &&
          //   task.WeakDetails[j].status !== 0 &&
          //   task.WeakDetails[j].status !== "2" &&
          //   task.WeakDetails[j].status !== 2
          // ) {
          //   task.WeakDetails[j].valid = false;
          //   task.WeakDetails[j].message = ``;
          //   this.snackBar.open(
          //     `${errorDay}-Timesheet entry should be more than 1:00`,
          //     "OK",
          //     {
          //       duration: 5000,
          //     }
          //   );
          // } else if (
          //   taskInSeconds > 28800 &&
          //   task.WeakDetails[j].status !== "0" &&
          //   task.WeakDetails[j].status !== 0 &&
          //   task.WeakDetails[j].status !== "2" &&
          //   task.WeakDetails[j].status !== 2
          // ) {
          //   task.WeakDetails[j].valid = false;
          //   task.WeakDetails[j].message = ``;
          //   this.snackBar.open(
          //     `${errorDay}-Timesheet entry should be up to 8 Hours`,
          //     "OK",
          //     {
          //       duration: 5000,
          //     }
          //   );
          // }
        });
      });
    }
  }

  /**function to covert hour to mins*/
  convertHoursToMins(hrs) {
    const a = hrs.toString().split(":");
    let minutes = 0;
    if (a[1]) {
      minutes = +a[0] * 60 + +a[1];
    } else {
      minutes = +Number(a[0]) * 60;
    }
    return minutes;
  }

  /**function to covert mins to hours*/
  convertMinsToHrsMins(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    const hrs = h < 10 ? "0" + h : h;
    const mns = m < 10 ? "0" + m : m;
    return `${hrs}:${mns}`;
  }

  /**function to change project*/
  projectDataChange(value, project?) {
    if (value === 'Other Project Support') {
      this.showPopup(); // Show the popup when "Other Project Support" is selected
      this.otherProjectSupport=true;
      this.getProjectDetailsForOtherProjectSupport(this.otherProjectSupport)
    }
    if (this.backupData !== value.taskType) {
      this.approved = false;
      this.unapproved = false;
      this.submitClicked = false;
    }
    this.taskList.forEach((element) => {
      if (element.activityType === value.taskType) {
        value.taskDescription = element.activityDescription;
        value.isValidTask = true;
      } else if (value["taskType"] && element.activityType !== value.taskType) {
        value.isValidTask = false;
      }
    });
    let selectedProject = null;

    // If the passed value is a string (assuming it's the project name),
    // search the projecttypeList for the full project object.
    if (typeof value === "string") {
      selectedProject = this.projecttypeList.find(
        (project) => project.Project === value  // Adjust property if project name uses a different key
      );
    } else if (value && value.wbscode) {
      // If a full project object is passed, use it directly.
      selectedProject = value;
    }

    if (selectedProject && selectedProject.wbscode) {
      const selectedWbscode = selectedProject.wbscode;
      // Filter targetIdList to get only the target IDs that match the selected project's wbscode.
      const matchingTargetIds = this.targetIdList.filter(
        (target) => target.wbscode === selectedWbscode
      );
      this.selectedTargetIdList = matchingTargetIds;
      console.log("Matching target IDs for selected project:", matchingTargetIds);
    } else {
      console.log("No matching project found for value:", value);
    }

  }

  /**function to change project task*/
  projectTaskChange(value, project?) {
    if (this.backupData !== value.taskType) {
      this.approved = false;
      this.unapproved = false;
      this.submitClicked = false;
    }
    // this.taskList.forEach((element) => {
    //   if (element.activityType === value.taskType) {
    //     value.taskDescription = element.activityDescription;
    //     value.isValidTask = true;
    //   } else if (value["taskType"] && element.activityType !== value.taskType) {
    //     value.isValidTask = false;
    //   }
    // });
    // if (this.config.businessUnit == "biologics") {
    //   this.checkValidTask(value);
    //   if (project.projectName.length > 0) {
    //     project.newProject = true;
    //   }
    // }
  }

  /**Function to compare day and return day in number */
  dayInNumber = (day) => {
    let dayObject = [
      { day: "monday", dayIn: 1 },
      { day: "tuesday", dayIn: 2 },
      { day: "wednesday", dayIn: 3 },
      { day: "thursday", dayIn: 4 },
      { day: "friday", dayIn: 5 },
      { day: "saturday", dayIn: 6 },
      { day: "sunday", dayIn: 7 },
    ];
    let match;
    dayObject.forEach((data) => {
      if (day == data.day) {
        match = data.dayIn;
      }
    });
    return match;
  };

  /**function to search ticket number*/
  searchTicketNumber(event, value) {
    if (this.backupData !== value.ticketNumber) {
      this.approved = false;
      this.unapproved = false;
      this.submitClicked = false;
      this.getTicketNumber(event.trim(), value);
    }
    if (value.ticketNumber === "") {
      value.newTicket = false;
      value.ticketDescription = "";
      this.isticketInvalid = false;
    }
  }

  /**function to save project*/
  saveProject(valid) {
    this.submitClicked = true;
    this.loaderFlag = true;
    const dailyMetrics = this.dateDisplay.map(day => ({
      date:day.date,
      stepsCompleted: day.steps,
      reactionsPerformed: day.reactions,
      productiveReactions: day.productiveReactions,
      successfulReactions:day.successfulReactions
    }));
    if (this.isEmployee) {
      this.userDetails = this.userInfo;
    } else {
      this.userDetails = this.user;
    }
    this.submitted = true;
    let flagEntry = false;
    let warn = false;
    let leaveApplied = false;
    let timesheetProject = this.projects;
    let submittedFuture = false;

    for (let i = 0; i < this.dateDisplay.length; i++) {
      if (!this.validateDailyMetrics(i)) {
        this.loaderFlag = false;
        this.submitClicked = false;
        return false;
      }
    }
    if (
      Number(this.datePipe.transform(new Date(), "ww")) <=
        Number(this.datePipe.transform(this.firstDay, "ww")) &&
      new Date(this.firstDay).getFullYear() ==
        new Date(this.lastDay).getFullYear() &&
      new Date(this.lastDay).getFullYear() >= new Date().getFullYear()
    ) {
      for (let index = 0; index < timesheetProject.length; index++) {
        timesheetProject[index].task.forEach((element) => {
          element.WeakDetails.forEach((weakData) => {
            if (
              weakData.FilledHrs != "00:00"
                ? this.dayInNumber(weakData.day) > new Date().getDay()
                : false
            ) {
              submittedFuture = true;
              // console.log(this.dayInNumber(weakData.day), new Date().getDay())
              return false;
            }
          });
        });
      }
    }
    // else if (
    //   this.datePipe.transform(new Date(), "ww") <=
    //     this.datePipe.transform(this.firstDay, "ww") &&
    //   this.datePipe.transform(new Date(), "ww") != "52"
    // ) {
    //   submittedFuture = true;
    // }
    else if (new Date() <= new Date(this.firstDay)) {
      submittedFuture = true;
    } else {
      submittedFuture = false;
    }
    if (new Date(this.firstDay).getFullYear() < new Date().getFullYear()) {
      submittedFuture = false;
    }
    if (new Date(new Date(this.firstDay).setHours(0, 0, 0, 0)) > new Date(new Date().setHours(0, 0, 0, 0)))
      {
        submittedFuture = true;
      }
    // console.log(new Date(this.firstDay).getFullYear())
    // console.log( new Date().getFullYear())
    // console.log(submittedFuture)
    if (submittedFuture) {
      this.loaderFlag = false;
      this.submitClicked = false;
      this.snackBar.open("Submit Timesheet cannot be in the future", "OK", {
        duration: 5000,
      });
      return false;
    } else {
      for (let m = 0; m < 7; m++) {
        if (this.Leave[m].leaveType == "fullDay") {
          leaveApplied = true;
        }
      }
      if (valid || leaveApplied) {
        for (var p = 0; p < this.projects.length; p++) {
          if (this.projects[p].projectName == "" && !leaveApplied) {
            warn = true;
          }
          if (this.projects[p].newProject == true) {
            this.project_invalid = false;
          }
          this.projecttypeList.forEach((element) => {
            if (element.Project.trim() == this.projects[p].projectName.trim()) {
              this.projects[p].projectId = element.projectID;
              this.projects[p].programName = element.programName;
              this.projects[p].projectManager = element.projectManager;
              this.projects[p].wbscode = element.wbscode;

            }
          });
          this.allprojecttypeList.forEach((element) => {
            if (element.Project.trim() == this.projects[p].projectName.trim()) {
              this.projects[p].projectId = element.projectID;
              this.projects[p].programName = element.programName;
              this.projects[p].projectManager = element.projectManager;
              this.projects[p].businessUnit = element.businessUnit;
              this.projects[p].wbscode = element.wbscode;

            }
          });
          if (this.projects[p].projectId == "") {
            this.listOptions[1].groups.forEach((element) => {
              if (element.name.trim() == this.projects[p].projectName.trim()) {
                this.projects[p].projectId = element._id;
              }
            });
          }
          for (var t = 0; t < this.projects[p].task.length; t++) {
            this.tasktypeList.forEach((element) => {
              if (element.activityType == this.projects[p].task[t].taskType) {
                this.projects[p].task[t].activityID = element.activityID;
              }
              if (this.projects[p].task[t].isValidTask === false) {
                this.task_invalid = true;
              }
              if (this.projects[p].task[t].newTicket == true) {
                this.isticketInvalid = true;
              }
              if (this.projects[p].task[t].ticketNumber == "") {
                this.projects[p].task[t].ticketDescription = "";
              }
            });
            this.targetList.forEach((target) => {
              if (target.targetID == this.projects[p].task[t].targetID) {
                // Validate that targetID exists in the list
                this.projects[p].task[t].targetID = target.targetID;
              }
            });

            this.projects[p].task.map((t) =>
              t.activityID == "" && t.taskType != ""
                ? (t.activityID = `id-${Date.now()}`)
                : t.activityID
            );
          }
        }

        // flagEntry =
        //   new Date(this.firstDay) > new Date("06/5/2023")
        //     ? this.validateTimeSheetTime()
        //     : false;
        if (
          this.config.businessUnit === "ipdo" ||
          this.config.businessUnit == "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          if (new Date(this.firstDay) > new Date("06/5/2023")) {
            this.totalValidate("submitted");
            this.validateEnteredInput();
          }

          if (
            !flagEntry &&
            !warn &&
            !this.LeaveFlag &&
            !this.project_invalid &&
            !this.isticketInvalid &&
            !this.invalidFormatedData &&
            !this.task_invalid
          ) {
            this.timesheetEntryService
              .saveEmployeeProjectDetails(
                this.projects,
                this.userDetails,
                (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")?1:this.weekNumber,
                (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")
        ? this.currentYear + 1
        : this.currentYear,
                this.Leave,
                this.rejected,
                this.timesheetIDs,
                dailyMetrics
              )
              .subscribe(
                (data) => {
                  this.dayTotalInfo = new Array(7).fill({
                    message: "",
                    className: "",
                  });
                  this.submitClicked = false;
                  this.loaderFlag = false;
                  this.snackBar.open(
                    "Timesheet Submitted for Approval Successfully",
                    "OK",
                    {
                      duration: 5000,
                    }
                  );
                  this.timesheetEntryService.sendDailyMetricstoGalaxy( (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
                  this.datePipe.transform(this.firstDay, "ww") == "53")?1:this.weekNumber,
                  (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
                  this.datePipe.transform(this.firstDay, "ww") == "53")?this.currentYear+1:this.currentYear).subscribe(
                    (data) => {
                      console.log("success from galaxy");})
                  this.getEmployeeTimesheet(this.weekNumber, 0, "");
                },
                (error) => {
                  this.submitClicked = false;
                  this.loaderFlag = false;
                  // this.validateEnteredInput();
                  if (!!error.error) {
                    this.snackBar.open(error.error.message, "OK", {
                      duration: 5000,
                    });
                  } else {
                    this.snackBar.open(error.message, "OK", {
                      duration: 5000,
                    });
                  }
                  this.submitClicked = false;
                  this.loaderFlag = false;
                }
              );
          } else {
            this.submitClicked = false;
            this.loaderFlag = false;
          }
        } else if (this.config.businessUnit === "accenture") {
          if (
            !flagEntry &&
            !warn &&
            !this.LeaveFlag &&
            !this.project_invalid &&
            !this.isticketInvalid
          ) {
            this.timesheetEntryService
              .saveEmployeeProjectDetails(
                this.projects,
                this.userDetails,
                (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")?1:this.weekNumber,
                (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")
        ? this.currentYear + 1
        : this.currentYear,
                this.Leave,
                this.rejected,
                this.timesheetIDs,
                dailyMetrics
              )
              .subscribe(
                (data) => {
                  this.submitClicked = false;
                  this.loaderFlag = false;
                  this.snackBar.open(
                    "Timesheet Submitted for Approval Successfully",
                    "OK",
                    {
                      duration: 5000,
                    }
                  );
                  this.timesheetEntryService.sendDailyMetricstoGalaxy(this.weekNumber,this.currentYear).subscribe(
                    (data) => {
                      console.log("success from galaxy");})
                  this.getEmployeeTimesheet(this.weekNumber, 0, "");
                },
                (error) => {
                  this.snackBar.open(error, "OK", {
                    duration: 5000,
                  });
                  this.submitClicked = false;
                  this.loaderFlag = false;
                }
              );
          } else {
            this.submitClicked = false;
            this.loaderFlag = false;
          }
        }
      } else {
        this.loaderFlag = false;
      }
    }
  }

  /**function to check timesheet entry with weekends data*/
  entryCheck(valid) {
    let noWeekendData = false;
    this.submitClicked = true;
    this.submitted = true;
    let leaveApplied = false;
    for (let m = 0; m < 7; m++) {
      if (this.Leave[m].leaveType === "fullDay") {
        leaveApplied = true;
      }
    }
    let taskControlsData = Object.keys(valid.controls).filter((task) =>
      task.startsWith("task")
    );

    taskControlsData.forEach((task) => {
      const taskControl = valid.controls[task];
      const validators =
        taskControl.validator && taskControl.validator({} as FormControl);
      const newValidators = validators ? validators : [];
      taskControl.setValidators(newValidators);
      taskControl.updateValueAndValidity();
    });

    if (valid || leaveApplied) {
      for (let p = 0; p < this.projects.length; p++) {
        this.projects[p].task.forEach((taskElement) => {
          taskElement.WeakDetails.forEach((weekDaysElement) => {
            if (
              weekDaysElement.status === "" &&
              weekDaysElement.FilledHrs != "00:00" &&
              (weekDaysElement.day === "sunday" ||
                weekDaysElement.day === "saturday")
            ) {
              noWeekendData = true;
              this.checkWeekendData(valid);
              return false;
            }
          });
        });
      }
      if (!noWeekendData) {
        this.saveProject(valid);
      }
    }
  }

  /**function to open dialog popup*/
  checkWeekendData(valid) {
    const data = {
      message:
        "Are you sure you want to submit Sunday/Saturday timesheet entry",
    };
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmPopUpComponent, {
        width: "400px",
        data: data,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.isWeekend = false;
          this.saveProject(valid);
        } else {
          this.isWeekend = true;
        }
      });
    }
  }

  /**function to check project*/
  checkProjectValid(project,j) {
      this.project_invalid = false;
    }

  checkValidTask(task) {
    // this.taskList.forEach((element) => {
    //   if (element.activityType === task.taskType) {
    //     task.isValidTask = true;
    //   }
    // });
    this.task_invalid = false;
  }

  /**function to check to ticket number*/
  checkTicketNumber(ticket, option) {
    ticket.newTicket = false;
    ticket.ticketDescription = ticket.ticketNumber
      ? option.ticketDescription
      : "";
    this.isticketInvalid = false;
  }

  /**function to save timesheet*/
  saveAsDraft(timeForm) {
    // this.submitClicked = true;
    this.submitted = true;
    this.loaderFlag = true;
    for (let i = 0; i < this.dateDisplay.length; i++) {
      if (!this.validateDailyMetrics(i)) {
        this.loaderFlag = false;
        this.submitClicked = false;
        return false;
      }
    }
    const dailyMetrics = this.dateDisplay.map(day => ({
      date:day.date,
      stepsCompleted: day.steps,
      reactionsPerformed: day.reactions,
      productiveReactions: day.productiveReactions,
      successfulReactions:day.successfulReactions
    }));
    if (new Date() <= new Date(this.firstDay)) {
      this.loaderFlag = false;
      this.snackBar.open("Save as Draft cannot be in the future week", "OK", {
        duration: 5000,
      });
      return false;
    }

    let taskControlsData = Object.keys(timeForm.controls).filter((task) =>
      task.startsWith("task")
    );

    taskControlsData.forEach((task) => {
      const taskControl = timeForm.controls[task];
      const validators =
        taskControl.validator && taskControl.validator({} as FormControl);
      const newValidators = validators ? validators : [];
      taskControl.setValidators(newValidators);
      taskControl.updateValueAndValidity();
    });

    if (!this.project_invalid && timeForm.valid) {
      if (this.isEmployee) {
        this.userDetails = this.userInfo;
      } else {
        this.userDetails = this.user;
      }
      let flagEntry = false;
      for (let p = 0; p < this.projects.length; p++) {
        if (this.projects[p].newProject == true) {
          this.project_invalid = false;
        }
        this.projecttypeList.forEach((element) => {
          if (element.Project.trim() == this.projects[p].projectName.trim()) {
            this.projects[p].projectId = element.projectID;
            this.projects[p].programName = element.programName;
            this.projects[p].projectManager = element.projectManager;
            this.projects[p].wbscode = element.wbscode;

          }
        });
        this.allprojecttypeList.forEach((element) => {
          if (element.Project.trim() == this.projects[p].projectName.trim()) {
            this.projects[p].projectId = element.projectID;
            this.projects[p].programName = element.programName;
            this.projects[p].projectManager = element.projectManager;
            this.projects[p].businessUnit = element.businessUnit;
            this.projects[p].wbscode = element.wbscode;

          }
        });

        if (this.projects[p].projectId == "") {
          this.listOptions[1].groups.forEach((element) => {
            if (element.name == this.projects[p].projectName) {
              this.projects[p].projectId = element._id;
            }
          });
        }
        for (let t = 0; t < this.projects[p].task.length; t++) {
          this.tasktypeList.forEach((element) => {
            if (element.activityType == this.projects[p].task[t].taskType) {
              this.projects[p].task[t].activityID = element.activityID;
            }
            if (this.projects[p].task[t].isValidTask === false) {
              this.task_invalid = true;
            }
            if (this.projects[p].task[t].newTicket == true) {
              this.isticketInvalid = true;
            }
            if (this.projects[p].task[t].ticketNumber == "") {
              this.projects[p].task[t].ticketDescription = "";
            }
          });
          this.targetList.forEach((target) => {
            if (target.targetID == this.projects[p].task[t].targetID) {
              // Validate that targetID exists in the list
              this.projects[p].task[t].targetID = target.targetID;
            }
          });
        }
        this.projects[p].task.map((t) =>
          t.activityID == "" && t.taskType != ""
            ? (t.activityID = `id-${Date.now()}`)
            : t.activityID
        );
      }
      // flagEntry =
      //   new Date(this.firstDay) > new Date("06/5/2023")
      //     ? this.validateTimeSheetTime()
      //     : false;

      if (
        this.config.businessUnit === "ipdo" ||
        this.config.businessUnit == "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        if (new Date(this.firstDay) > new Date("06/5/2023")) {
          this.totalValidate("drafted");
          this.validateEnteredInput();
        }

        if (
          !flagEntry &&
          !this.LeaveFlag &&
          !this.project_invalid &&
          this.projects[0].projectName !== "" &&
          !this.isticketInvalid &&
          !this.invalidFormatedData &&
          !this.task_invalid
        ) {
          // console.log(this.projects, this.userDetails, this.weekNumber, this.currentYear, this.Leave, this.timesheetIDs)
          this.timesheetEntryService
            .saveEmployeeAsDraftProjectDetails(
              this.projects,
              this.userDetails,
              (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")?1:this.weekNumber,
                (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")
        ? this.currentYear + 1
        : this.currentYear,
              this.Leave,
              this.timesheetIDs,
              dailyMetrics
            )
            .subscribe(
              (data) => {
                this.loaderFlag = false;
                this.dayTotalInfo = new Array(7).fill({
                  message: "",
                  className: "",
                });
                this.snackBar.open("Timesheet saved as draft", "OK", {
                  duration: 5000,
                });
                this.getEmployeeTimesheet(this.weekNumber, 0, "");
              },
              (error) => {
                this.submitClicked = false;
                this.loaderFlag = false;
                // this.validateEnteredInput();

                if (!!error.error) {
                  this.snackBar.open(error.error.message, "OK", {
                    duration: 5000,
                  });
                } else {
                  this.snackBar.open(error.message, "OK", {
                    duration: 5000,
                  });
                }
              }
            );
        } else {
          this.submitClicked = false;
        }
      } else if (this.config.businessUnit === "accenture") {
        if (
          !flagEntry &&
          !this.LeaveFlag &&
          !this.project_invalid &&
          this.projects[0].projectName !== "" &&
          !this.isticketInvalid
        ) {
          this.timesheetEntryService
            .saveEmployeeAsDraftProjectDetails(
              this.projects,
              this.userDetails,
              (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")?1:this.weekNumber,
                (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
     this.datePipe.transform(this.firstDay, "ww") == "53")
        ? this.currentYear + 1
        : this.currentYear,
              this.Leave,
              this.timesheetIDs,
              dailyMetrics
            )
            .subscribe(
              (data) => {
                this.loaderFlag = true;
                this.snackBar.open("Timesheet saved as draft", "OK", {
                  duration: 5000,
                });
                this.getEmployeeTimesheet(this.weekNumber, 0, "");
              },
              (error) => {
                this.snackBar.open(error, "OK", {
                  duration: 5000,
                });
                this.submitClicked = false;
                this.loaderFlag = false;
              }
            );
        } else {
          this.submitClicked = false;
        }
      }
    }
    this.loaderFlag = false;
  }

  isDateDisabled(displayDateDate: number): boolean {
    const today = new Date(new Date().setHours(0, 0, 0, 0))
    // Check if displayDateDate is within the range of firstDay and lastDay
    if (new Date(new Date(this.firstDay).setHours(0, 0, 0, 0)) <= today  && today <= new Date(new Date(this.lastDay).setHours(0, 0, 0, 0))) {
        if((displayDateDate-today.getDate())> 0 && (displayDateDate-today.getDate())< 7)
        {
        return displayDateDate > today.getDate(); // Disable if displayDateDate is later than the current day
        }
    }

    return false; // Default to enabled otherwise
}

  /**function to validate timesheet time*/
  validateTimeSheetTime() {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let flagEntry = false;
    // let exceedTime = this.convertHoursToMins(this.timesheetConfig.exceedTimeLimit);
    // let lessime = this.convertHoursToMins(this.timesheetConfig.lessTimeLimit);
    const exceedTime = 480;
    const lessTime = 60;
    for (let i = 0; i < 7; i++) {
      if (
        this.config.businessUnit == "ipdo" ||
        this.config.businessUnit == "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        const enteredTime = this.convertHoursToMins(this.dayTotal[i]);
        if (enteredTime > exceedTime) {
          this.loaderFlag = false;
          flagEntry = true;
          const data = {
            message: days[i] + " Total time exceed 08:00 hours time limit",
          };
          // if (this.dialog.openDialogs.length === 0) {
          //   const dialogRef = this.dialog.open(ErrorPopUpComponent, {
          //     width: '320px',
          //     data: data
          //   });
          //   dialogRef.afterClosed().subscribe(result => {
          //     if (result === true) {
          //     }
          //   });
          // }
          break;
        }
      } else if (this.config.businessUnit == "accenture") {
        if (this.dayTotal[i] > 23.5) {
          flagEntry = true;
          this.snackBar.open(
            days[i] + " Total time exceed 23.5 hours time limit",
            "OK",
            {
              duration: 5000,
            }
          );
          break;
        }
      }
    }
    return flagEntry;
  }

  /**function to filter entries*/
  filterEntities(event: any, project) {
    this.isReadOnly=true;
    this.project_invalid = false;
    project.newProject = true;
    const searchItem = event.target.value.toLowerCase();
    if (
      this.config.businessUnit == "ipdo" ||
      this.config.businessUnit == "biologics" ||
      this.config.businessUnit === "chinateam" ||
      this.config.businessUnit === "aps"
    ) {
      if (searchItem == "Functional" && this.taskListFlag) {
        project.taskList = JSON.parse(
          JSON.stringify(
            this.taskList.filter((entity) => entity.activityFlag == false)
          )
        );
      } else if (this.taskListFlag) {
        project.taskList = JSON.parse(
          JSON.stringify(
            this.taskList.filter((entity) => entity.activityFlag == true)
          )
        );
      }
    } else {
      if (this.taskListFlag) {
        project.taskList = JSON.parse(
          JSON.stringify(
            this.taskList.filter((entity) => entity.activityFlag == true)
          )
        );
      }
    }
    this.filteredOptions = JSON.parse(JSON.stringify(this.listOptions));
    if (searchItem.trim().length > 0) {
      const input = searchItem.toLowerCase();
      this.filteredOptions.filter((group) => {
        group.groups = group.groups.filter((rowItem) => {
          const item = { ...rowItem };
          const projectName = (item["Project"] || "").toLowerCase();
          const libraryname = (item["name"] || "").toLowerCase();
          const isMatch =
            projectName.includes(input) || libraryname.includes(input);
          if (isMatch) {
            return rowItem;
          }
        });
        return group;
      });
    } else {
      this.filteredOptions = this.listOptions;
    }
  }

  // Restrict user from typing other than number
  _keyPress(event: any) {
    const pattern = /[0-9\.]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
    const RE = /^\d*\.?\d{0}$/;
    if (RE.test(event.target.value)) {
    } else {
      event.preventDefault();
    }
  }

  /**function to get rm employee list*/
  getrmEmployeeLists() {
    this.employeelistarr = [];
    this.dashboardService.getDashboardEmployeeList().subscribe((data) => {
      if (data.payload.employeeCount) {
        data.payload.employeeCount.empList.forEach((value) => {
          this.employeelistarr.push(value);
        });
      }
    });
  }

  /**function to filter employee entries*/
  filterEmployeeEntities(event: any) {
    const searchItem = event.target.value;
    if (event.target.value !== "undefined") {
      this.filteredEmpOptions = this.employeelistarr.filter(
        (s) => s.Empname.toLowerCase().indexOf(searchItem.toLowerCase()) == 0
      );
    }
  }

  /**function to select employee selected*/
  employeeSelected(option) {
    this.employeeNo = option.Empno;
    this.hasRM = option.RMCode ? option.RMCode : "";
    this.getEmployeeTimesheet(this.currentWeek, 0, "");
    this.showTimesheet = true;
    this.userInfo = option;
    this.checkEmployeeLockedStatus(option.lockedDetails);
  }

  /**function to change selected*/
  onSelectionChange(event) {
    const currentDay = new Date();
    this.getWeekDays(currentDay);
    if (event.target.value == "emp") {
      this.isEmployee = true;
      this.empName = "";
      this.showTimesheet = false;
      this.getrmEmployeeLists();
    } else {
      this.isEmployee = false;
      this.employeeNo = this.user.Empno;
      this.showTimesheet = true;
      this.getEmployeeTimesheet(this.currentWeek, 0, "");
      this.checkEmployeeLockedStatus(null);
    }
  }

  /**function to select activity*/
  taskSelected(projectIndex, row, project, rowD) {
    this.projects[projectIndex].taskList.forEach((ele, i) => {
      // if (ele.activityType == row) {
      //   this.projects[projectIndex].taskList[i].selectedFlag = true;
      // }
    });
  }

  /**function to get ticket number*/
  getTicketNumber(searchItem, ticket) {
    ticket.newTicket = true;
    if (searchItem.length > 0) {
      this.timesheetEntryService
        .getTicketNumber(searchItem)
        .subscribe((data) => {
          if (!!data.payload && data.payload.length > 0) {
            this.tickets = data.payload;
            this.filteredTicketOptions = this.tickets;
            // this.noTicket =  false;
          } else {
            // this.noTicket =  true;
          }
        });
    }
  }

  /**function to get week timesheet*/
  getEmployeeWeekTimesheet() {
    this.navigateDate = this.timesheetApprovalService.getSelectedRowData();
    if (this.navigateDate !== undefined) {
      const year = new Date().getFullYear();
      const week = this.navigateDate.weekNumber - 1;
      const d = new Date("Jan 01, " + year + " 01:00:00");
      const w = d.getTime() + 604800000 * week;
      const weekDay = new Date(w);
      this.getWeekDays(weekDay);
      setTimeout(
        function (self) {
          self.getEmployeeTimesheet(self.navigateDate.weekNumber, 0);
        },
        1000,
        this
      );
    }
  }

  /**function to get locked status*/
  checkEmployeeLockedStatus(status) {
    if (!status) {
      this.timesheetEntryService.getLockedStatus().subscribe((data) => {
        const lockedResult = data.payload.lockedDetails;
        const unlockRequest = data.payload.unlockRequest;
        this.isAdherence = lockedResult.isLocked ? true : false;
        this.isCompliance = lockedResult.isNonCompliance ? true : false;
        this.hasRM = data.payload.RMCode;
        if (!!unlockRequest.Requested) {
          this.unlockRequest = true;
          this.timesheetStatus = "YOUR TIMESHEET IS LOCKED";
        } else {
          this.unlockRequest = false;
          if (this.isAdherence) {
            this.timesheetStatus = "YOUR TIMESHEET IS SET TO NON ADHERENCE";
          }
          if (this.isCompliance) {
            this.timesheetStatus = "YOUR TIMESHEET IS SET TO NON COMPLIANCE";
          }
        }
      });
    } else if (status) {
      this.isAdherence = status.isLocked ? true : false;
      this.isCompliance = status.isNonCompliance ? true : false;
      this.isEmployee = true;
      if (this.isAdherence) {
        this.timesheetStatus = "EMPLOYEE TIMESHEET IS SET TO NON ADHERENCE";
      }
      if (this.isCompliance) {
        this.timesheetStatus = "EMPLOYEE TIMESHEET IS SET TO NON COMPLIANCE";
      }
    }
  }

  /**function to request for unlock*/
  requestunlock() {
    if (
      this.config.businessUnit != "ipdo" &&
      this.config.businessUnit != "chinateam" &&
      this.config.businessUnit != "aps"
    ) {
      if (!this.unlockRequest && !this.isEmployee) {
        if (this.dialog.openDialogs.length === 0) {
          const dialogRef = this.dialog.open(RequestUnlockDialogComponent, {
            width: "auto",
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.checkEmployeeLockedStatus(null);
          });
        }
      }
    }
  }

  /**function to get previous project detail*/
  getPreviousWeekProject() {
    this.getEmployeeTimesheet(this.getPreviousWeekDate, 1, this.firstDay);
  }

  leaveApply() {
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(LeavePopUpComponent, {
        width: "600px",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const data = {
            from: result.fromDate,
            to: result.toDate,
            reason: result.reason,
            status: true,
          };
          this.timesheetEntryService.applyLeave(data).subscribe((res) => {
            if (!!res.payload) {
              this.getEmployeeTimesheet(this.weekNumber, 0, "");
              this.snackBar.open(res.payload.message, "OK", {
                duration: 5000,
              });
            }
          });
        }
      });
    }
  }

  private filterActivity(value: string, activities) {
    const filterValue = value.toLowerCase();
    this.filteredActivityOptions = activities.filter((option) =>
      option.activityType.toLowerCase().includes(filterValue)
    );
  }

  private filterTargetIds(value: string, targetList: any[]) {
    const filterValue = value.toLowerCase();

    // Check if targetList is defined and is an array
    if (Array.isArray(targetList)) {
        this.filteredTargetIDOptions = targetList.filter(target =>
            target.targetID.toLowerCase().includes(filterValue)
        );
    } else {
        console.warn("targetList is not defined or not an array");
        this.filteredTargetIDOptions = []; // Set to an empty array if targetList is invalid
    }
}

  private filterProjects(value: string): void {
    const filterValue = value ? value.toLowerCase().trim() : ""; // Safeguard against undefined or null values

    // Deduplicate projects and handle missing "Project" key
    this.uniqueProjects = Array.from(
        new Map(
            this.allProjects
                .filter(project => project && project["Project"]) // Filter out invalid objects
                .map(project => [project["Project"].toLowerCase(), project]) // Ensure "Project" exists
        ).values()
    );

    // If filterValue is empty, return all unique projects
    if (!filterValue) {
        this.allProjectOptions = this.uniqueProjects;
        return;
    }

    // Filter the projects based on the input value
    this.allProjectOptions = this.uniqueProjects.filter((option) =>
        option["Project"].toLowerCase().includes(filterValue)
    );

    this.selectedProject = ""; // Reset selected project if needed
}



  showPopup(): void {
    this.isPopupVisible = true;  // Show the popup
  }

  hidePopup(): void {
    this.isPopupVisible = false;  // Hide the popup
  }

  selectProject(projectName: string, j: number): void {
    if (this.projects[j]) {
        this.projects[j].projectName = projectName;
    }
    this.hidePopup(); // Close the popup
}


  totalValidate(status) {
    // if (status === "submitted") {
    //   this.dayTotal.forEach((total, index) => {
    //     if (total !== "00:00") {
    //       const a = total.split(":");
    //       const timeInSeconds = +a[0] * 60 * 60 + +a[1] * 60;
    //       if (timeInSeconds < 3600) {
    //       }
    //       if (timeInSeconds > 28800) {
    //         this.loaderFlag = false;
    //         this.dayTotalInfo[index] = {
    //           message: "Timesheet entry should be up to 8 Hours",
    //           className: "input-danger",
    //         };
    //         this.snackBar.open(
    //           "Timesheet entry should be between 1:00 and 08:00",
    //           "OK",
    //           {
    //             duration: 3000,
    //           }
    //         );
    //       }
    //     }
    //   });
    // }
    // if (status === "drafted") {
    //   this.dayTotal.forEach((total, index) => {
    //     if (total !== "00:00") {
    //       const a = total.split(":");
    //       const timeInSeconds = +a[0] * 60 * 60 + +a[1] * 60;
    //       if (timeInSeconds > 28800) {
    //         this.loaderFlag = false;
    //         this.dayTotalInfo[index] = {
    //           message: "Timesheet entry should be up to 8 Hours",
    //           className: "input-danger",
    //         };
    //         this.snackBar.open(
    //           "Timesheet entry should be up to 8 Hours",
    //           "OK",
    //           {
    //             duration: 5000,
    //           }
    //         );
    //       }
    //     }
    //   });
    // }
  }

  checkTotalHours(total, dayTotal) {
    if (total !== "00:00" && !!dayTotal.message) {
      const a = total.split(":");
      const timeInSeconds = +a[0] * 60 * 60 + +a[1] * 60;
      if (timeInSeconds < 3600) {
        return "input-danger";
      }
      if (timeInSeconds > 28800) {
        return "input-danger";
      }
      if (timeInSeconds >= 3600 && timeInSeconds <= 28800) {
        return "input-valid";
      }
    }
  }

  deleteEntry(i, j, rowData, taskDetails) {
    if (this.checkRowList(rowData)) {
      const data = {
        message: "Are you sure you want to delete entry",
      };
      if (this.dialog.openDialogs.length === 0) {
        const dialogRef = this.dialog.open(DeleteEntryPopUpComponent, {
          width: "400px",
          data: data,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result === true) {
            this.remove(i, j, rowData, taskDetails);
          }
        });
      }
    } else {
      this.snackBar.open("You cannot delete Unapproved/Approved entry", "OK", {
        duration: 5000,
      });
    }
  }

  selectChange($event) {
    //In my case $event come with a id value
    this.selectedData = this.listOptions[$event];
  }

  /**function to unsubscribe api request when component destroyed*/
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-entry/timesheet-entry.component.ts